// courseSlice.js
const initialState = {
  courseData: [],
};

// Action types (UPPER_SNAKE_CASE for constants)
const SET_COURSE_DATA = "SET_COURSE_DATA";
const CLEAR_COURSE_DATA = "CLEAR_COURSE_DATA";

// Action creators (camelCase)
export const setCourseData = (data) => ({
  type: SET_COURSE_DATA,
  payload: data,
});

export const clearCourseData = () => ({
  type: CLEAR_COURSE_DATA,
});

// Reducer (PascalCase for reducer function)
const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COURSE_DATA:
      return { ...state, courseData: action.payload };
    case CLEAR_COURSE_DATA:
      return { ...state, courseData: [] };
    default:
      return state;
  }
};

export default courseReducer;
